import { localeFromPath, translatePath } from '../i18n/routes';

const SITE_URL = (process.env.REACT_APP_SITE_URL || process.env.REACT_APP_PUBLIC_SITE_URL || process.env.NEXT_PUBLIC_SITE_URL || 'https://le-placard-a-doudous.com').replace(/\/$/, '');

function upsertMeta(selector, createAttrs, valueAttr, value) {
    let tag = document.querySelector(selector);
    if (!tag) {
        tag = document.createElement('meta');
        Object.entries(createAttrs).forEach(([key, attrValue]) => tag.setAttribute(key, attrValue));
        document.head.appendChild(tag);
    }
    tag.setAttribute(valueAttr, value);
}

function upsertCanonical(url) {
    let tag = document.querySelector('link[rel="canonical"]');
    if (!tag) {
        tag = document.createElement('link');
        tag.setAttribute('rel', 'canonical');
        document.head.appendChild(tag);
    }
    tag.setAttribute('href', url);
}

// Versions FR / EN d'une même page, pour que Google relie les deux langues.
function upsertAlternates(pathname) {
    document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(tag => tag.remove());
    const fr = translatePath(pathname, 'fr');
    const en = translatePath(pathname, 'en');
    if (fr === en) return;
    [['fr', fr], ['en', en], ['x-default', fr]].forEach(([hreflang, href]) => {
        const tag = document.createElement('link');
        tag.setAttribute('rel', 'alternate');
        tag.setAttribute('hreflang', hreflang);
        tag.setAttribute('href', absoluteUrl(href));
        document.head.appendChild(tag);
    });
}

export function absoluteUrl(path = '/') {
    return `${SITE_URL}${path}`;
}

// Utility for setting page-level SEO meta tags
export function useSEO(title, description, path) {
    if (typeof window !== 'undefined') {
        const pagePath = path || window.location.pathname;
        const canonical = absoluteUrl(pagePath);
        upsertAlternates(pagePath);
        document.title = title;
        upsertMeta('meta[name="description"]', { name: 'description' }, 'content', description);
        upsertCanonical(canonical);

        // Open Graph
        const ogImage = absoluteUrl('/og-default.jpg');
        const ogTags = { 'og:title': title, 'og:description': description, 'og:type': 'website', 'og:url': canonical, 'og:image': ogImage, 'og:site_name': 'Le Placard à Doudous', 'og:locale': localeFromPath(pagePath) === 'en' ? 'en_GB' : 'fr_FR' };
        Object.entries(ogTags).forEach(([prop, content]) => {
            upsertMeta(`meta[property="${prop}"]`, { property: prop }, 'content', content);
        });
        upsertMeta('meta[name="twitter:card"]', { name: 'twitter:card' }, 'content', 'summary_large_image');
        upsertMeta('meta[name="twitter:title"]', { name: 'twitter:title' }, 'content', title);
        upsertMeta('meta[name="twitter:description"]', { name: 'twitter:description' }, 'content', description);
        upsertMeta('meta[name="twitter:image"]', { name: 'twitter:image' }, 'content', ogImage);
    }
}
